//* 组件属性
import type { ModuleTableOption } from "../index";
//* 样式
import css from "../style/index.module.less";

export const useOptions = () => {
    //* 插件
    const i18n = useI18n();
    const table: ModuleTableOption[] = [
        {
            key: "clinvar",
            name: "ClinVar",
            width: 120,
            align: "singularity",
            fixed: true,
            merge: (datas, data, index) => {
                const upper = datas?.[index - 1] || {};
                if (upper && upper?.clinvar == data?.clinvar) return { rowspan: 0 };
                else {
                    const result = { rowspan: 1 };
                    for (let i = index + 1; i < datas.length; i++) {
                        if (datas[i]?.clinvar == data?.clinvar) result.rowspan += 1;
                        else {
                            return result;
                        }
                    }

                    return result;
                }
            },
        },
        { key: "gene", name: i18n.t("Gene"), width: 160, align: "singularity", control: "sort", fixed: true },
        {
            key: "mutation_transcript",
            name: i18n.t("Nucleotide"),
            width: 200,
            align: "singularity",
            control: "sort",
            explain: i18n.t("NucleotideHint"),
            fixed: true,
        },
        {
            key: "mutation_protein",
            name: i18n.t("AminoAcid"),
            width: 200,
            align: "singularity",
            control: "sort",
            explain: i18n.t("AminoAcidHint"),
            hidden: true,
            // fixed: true,
        },
        {
            key: "transcript",
            name: i18n.t("TranscriptID"),
            width: 240,
            align: "singularity",
            explain: i18n.t("TranscriptIDHint"),
        },
        { key: "variant_region", name: i18n.t("MutationRegion"), width: 200, align: "center", explain: i18n.t("MutationRegion"), hidden: true },
        { key: "variant_type", name: i18n.t("MutationType"), width: 160, align: "center", hidden: true },
        {
            key: "clinical",
            name: i18n.t("ClinicalSignificance"),
            width: 200,
            align: "center",
            explain:
                i18n.locale.value == "zh"
                    ? ""
                    : "P - Pathogenic<br> LP - Likely Pathogenic<br> B - Benign<br> LB - Likely Benign<br> VUS - Uncertain",
            hidden: true,
        },
        {
            key: "rate",
            name: i18n.t("Frequency"),
            width: 200,
            align: "singularity",
            control: "sort",
            explain: i18n.t("FrequencyHint"),
            hidden: true,
        },
        {
            key: "related_diseases",
            name: i18n.t("DiseaseCount"),
            width: 180,
            align: "singularity",
            control: "sort",
            explain: i18n.t("DiseaseCountHint"),
            hidden: true,
        },
        {
            key: "references",
            name: i18n.t("Publications"),
            width: 180,
            align: "singularity",
            control: "sort",
            explain: i18n.t("PublicationsHint"),
            hidden: true,
        },
    ];

    //* 可隐藏的列
    const rows = table
        .filter((value) => value.hidden)
        .map((value) => ({
            value: value.key,
            label: value.name,
        }));

    //* 版本颜色
    const variant = { "CDS": css.cds, "Inrton": css.inrton, "5'UTR": css.utr, "3'UTR": css.utr, "Uncertain": css.uncertain } as {
        [name: string]: string | undefined;
    };

    //* 排序对照表
    const sort = {
        gene: "gene_name",
        mutation_transcript: "transcript_change",
        mutation_protein: "protein_change",
        transcript: "transcript_vid",
        rate: "frequency",
        related_diseases: "disease_qty",
        references: "paper_qty",
    } as { [name: string]: string };

    return { table, rows, variant, sort };
};
